import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/AuthContextComponent";
import LoginInput from "../../components/LoginComponent";
import { DATATYPE } from "../../lib/enums/index";
import Modal from "../../components/modal/ModalComponent";
import useUserLogin from "../../hooks/UserLoginhook";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import PuffLoader from "../../components/loading/OnBoardLoading";
import { useAppContext } from "../../components/VersionContext";

const Login: React.FC = () => {
  const { userInfo } = useContext(AuthContext);
  const {
    feversion,
    openModalLogin,
    openModalForgertPassword,
    password,
    showPassword,
    time,
    userId,
    userData,
    questions,
    forgetPasswordError,
    userPasswordError,
    userUsernameError,
    customColor,
    customImg,
    textColorClass,
    isPasswordHovered,
    isForgotPasswordHovered,
    CustomAccount,
    setOpenModalLogin,
    setOpenModalForgetPassword,
    setIsPasswordHovered,
    setIsForgotPasswordHovered,
    handleSubmit,
    handlePasswordChange,
    handleUsernameChange,
    handleMouseDown,
    handleMouseUp,
    handleMouseLeave,
    handleForgetPasswordClick,
  } = useUserLogin();

  const { beversion } = useAppContext();
  const [loading, setLoading] = useState(true);
  const sendType = userInfo?.notification || "";

  useEffect(() => {
    const fetchData = async () => {
      try {
        await CustomAccount();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const backgroundColor = userInfo?.theme === "DARK" ? "#24292e" : "white";

  return (
    <div
      className="relative flex flex-wrap items-center justify-center min-h-[100dvh] w-full font-sans"
      style={{
        fontFamily: `"Poppins", "Segoe UI", "-apple-system", "BlinkMacSystemFont", "sans-serif"`,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      }}
    >
      {loading ? (
        <div className="flex justify-center max-w-[1240px] mx-auto px-4 h-full items-center p-96">
          <PuffLoader />
        </div>
      ) : (
        <div
          className="w-[400px] rounded-2xl shadow-2xl shadow-black/20 bg-white px-8 py-12 flex flex-col items-center"
          style={{ backgroundColor }}
        >
          <div className="text-center">
            <label
              style={{ color: textColorClass }}
              className="text-2xl font-semibold"
            >
              Disbursement
            </label>
          </div>

          <img
            src={customImg || ""}
            alt="Logo"
            className="h-20 my-6 transition-transform duration-300 hover:scale-110"
          />

          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            className="flex flex-col w-[80%] gap-3"
          >
            {/* Username */}
            <div className="flex flex-col w-full gap-1">
              <LoginInput
                type={DATATYPE.TEXT}
                label="Username"
                name="username"
                placeholder="Username"
                value={userId}
                error={forgetPasswordError || userUsernameError}
                onChange={handleUsernameChange}
              />
              {(forgetPasswordError || userUsernameError) && (
                <span className="pl-1 text-custom-default text-custom-micro">
                  *Username is required!
                </span>
              )}
            </div>

            {/* Password */}
            <div className="flex flex-col w-full gap-1">
              <LoginInput
                type={showPassword ? "text" : "password"}
                label="Password"
                name="password"
                placeholder="Password"
                value={password}
                error={userPasswordError}
                onChange={handlePasswordChange}
                hoverColor={customColor}
                icon={
                  <span
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseLeave}
                    onMouseEnter={() => setIsPasswordHovered(true)}
                    style={{
                      color: isPasswordHovered ? customColor : "",
                      transition: "color 0.3s",
                    }}
                    className="cursor-pointer"
                  >
                    {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                  </span>
                }
              />
              {userPasswordError && (
                <span className="pl-1 text-custom-default text-custom-micro">
                  *Password is required!
                </span>
              )}
            </div>

            {/* Submit Button */}
            <div className="mt-2">
              <button
                type={DATATYPE.SUBMIT}
                className={`w-full h-10 rounded text-white font-medium transition-all duration-300 ${
                  customColor
                    ? `hover:scale-105`
                    : `hover:bg-custom-default-hover hover:shadow-md`
                }`}
                style={{ backgroundColor: customColor }}
              >
                Login
              </button>
            </div>
          </form>

          {openModalLogin && (
            <Modal
              footer="Didn't receive a code?"
              type="OTP"
              header="One Time Pin"
              transType="loginOTP"
              label={
                sendType === "EMAIL"
                  ? "An OTP has been sent to your Email to validate your request."
                  : "An OTP has been sent to your SMS to validate your request."
              }
              isClose={false}
              userId={userId}
              userData={userData}
              setOpenOTP={setOpenModalLogin}
              otpTimer={time}
              otpType="LOGIN"
              sendType={sendType}
            />
          )}

          <div className="flex items-center justify-between w-[80%] mt-4">
            <button
              onClick={handleForgetPasswordClick}
              className="text-sm transition-all duration-300 hover:scale-105"
              onMouseEnter={() => setIsForgotPasswordHovered(true)}
              onMouseLeave={() => setIsForgotPasswordHovered(false)}
              style={{
                color: isForgotPasswordHovered ? customColor : "",
              }}
            >
              Forgot Password?
            </button>
          </div>

          {openModalForgertPassword && (
            <Modal
              type="ForgetPassword"
              header="Secret Question"
              transType=""
              isClose={false}
              userId={userId}
              otpTimer={time}
              otpType="LOGIN"
              sendType={sendType}
              setOpenOTP={setOpenModalForgetPassword}
              questions={questions}
              toggleClose={() => handleForgetPasswordClick(false)}
            />
          )}

          <div className="mt-6 text-xs text-center text-gray-500">
            Version: {feversion}.{beversion}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
